import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";

//const baseURL = "http://localhost:15301";
const baseURL = "https://lkmtraining.nomination.accenture.com/LKMtrainingNomination-apis";

export const BusinessPOCSlice = createSlice({
 name: "businessPOC",
 initialState: {
  error: false,
  trainingData: [],
  nominationData: [],
  enterpriseID: "",
  uploadedCourseList: [],
  individualCourseList: [],
  currentMonth: "",
  currentMonthIndex: "",
 },

 reducers: {
  setTrainingData: (state, { payload }) => {
   state.error = false;
   state.trainingData = payload;
  },
  setNominationData: (state, { payload }) => {
   state.error = false;
   state.nominationData = payload;
  },
  // setUpdatedStatus: (state, { payload }) => {
  //  state.error = false;

  //  state.nominationData.map((val) => {
  //   if (val.id == payload.id) {
  //    val.status = payload.status;
  //   }
  //  });
  // },
  setEnterpriseID: (state, { payload }) => {
   state.enterpriseID = payload.name;
  },
  setUploadedCourseList: (state, { payload }) => {
   state.uploadedCourseList = payload;
  },
  setIndividualCourseList: (state, { payload }) => {
   state.individualCourseList = payload;
  },
  setCurrentMonth: (state, { payload }) => {
   state.currentMonth = payload;
  },
  setCurrentMonthIndex: (state, { payload }) => {
   state.currentMonthIndex = payload;
  },

  setError: (state) => {
   state.error = true;
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setTrainingData,
 setError,
 setNominationData,
 setUpdatedStatus,
 setEnterpriseID,
 setUploadedCourseList,
 setIndividualCourseList,
 setCurrentMonth,
 setCurrentMonthIndex,
} = BusinessPOCSlice.actions;

export default BusinessPOCSlice.reducer;

export function getTrainingListData(month) {
 return (dispatch) => {
  Axios.get(`${baseURL}/fetchTrainingList/${month}`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setTrainingData(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}

export function getNominationListData() {
 return (dispatch) => {
  Axios.get(`${baseURL}/fetchNominationList`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setNominationData(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function getFilteredNominationListData(filterValue) {
 return (dispatch) => {
  Axios.get(`${baseURL}/fetchfilterNominationList/${filterValue}`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setNominationData(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

// export function updateTHStatus(id, status) {
//  return (dispatch) => {
//   Axios.post(`${baseURL}/updateTHStatus/${id}/${status}`)
//    .then((res) => {
//     dispatch(setUpdatedStatus({ id, status }));
//    })
//    .catch((err) => {
//     dispatch(setError(err));

//     console.error("error is", err);
//    });
//  };
// }

export function updateLoginUserName(name) {
 return (dispatch) => {
  dispatch(setEnterpriseID({ name }));
 };
}

export function fetchPOCUploadedData(username) {
 return (dispatch) => {
  Axios.get(`${baseURL}/fetchpocUploadeddata/${username}`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(
     fetchPOCUploadedIndividualList(res.data[0].courseName, res.data[0].date, username)
    );
    dispatch(setUploadedCourseList(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function fetchPOCUploadedIndividualList(username) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/fetchpocUploadedindividualList`,
   { username },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setIndividualCourseList(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function getCurrentMonth() {
 return (dispatch) => {
  const currentDate = new Date();
  console.log("ufhbrh", currentDate);
  const currentMonthIndex = currentDate.getMonth() + 1;

  const monthNames = [
   "January",
   "February",
   "March",
   "April",
   "May",
   "June",
   "July",
   "August",
   "September",
   "October",
   "November",
   "December",
  ];

  const currentMonthName = monthNames[currentMonthIndex];
  console.log("setCurrentMonth", currentMonthIndex);
  dispatch(setCurrentMonth(currentMonthName));
  dispatch(setCurrentMonthIndex(currentMonthIndex));
 };
}
